import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"; // ES 2015
import timeZone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timeZone);
export function cn() {
  for (var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++) {
    inputs[_key] = arguments[_key];
  }
  return twMerge(clsx(inputs));
}
export const isDev = () => {
  if (!window) {
    return false;
  }
  if (window.location.href.includes("localhost")) {
    return true;
  }
  return false;
};
export function getUTC8TimeString() {
  const formattedTime = dayjs().tz("Asia/Shanghai").format("YYYY-MM-DD HH:mm:ss");
  return formattedTime;
}